import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useWatchButton } from '../../../WatchButton/useWatchButton';

interface Props {
  user: PapiUser;
}

const WatchButton: React.FC<Props> = ({ user }) => {
  const { isWatching, text, onClick, biData } = useWatchButton(user);

  return (
    <GhostButton
      size="small"
      variant="main"
      biData={biData}
      icon={isWatching ? CheckIcon : AddIcon}
      onClick={onClick}
    >
      {text}
    </GhostButton>
  );
};
WatchButton.displayName = 'WatchButton';

export default WatchButton;
